import { render } from "./PermissionItems.vue?vue&type=template&id=6a8c1d11&scoped=true&ts=true"
import script from "./PermissionItems.vue?vue&type=script&lang=ts"
export * from "./PermissionItems.vue?vue&type=script&lang=ts"

import "./PermissionItems.vue?vue&type=style&index=0&id=6a8c1d11&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8c1d11"]])

export default __exports__